(function(){
  if(window.__miPP)return;window.__miPP=1;
  function init(root){
    root.querySelectorAll('[data-mi-track]').forEach(function(t){
      if(t.__mi)return;t.__mi=1;
      var bar=t.parentElement.querySelector('[data-mi-bar] span');if(!bar)return;
      function u(){var max=t.scrollWidth-t.clientWidth,w=Math.min(1,Math.max(.15,t.clientWidth/t.scrollWidth)),p=max>0?t.scrollLeft/max:0;
        bar.style.width=(w*100)+'%';bar.style.transform='translateX('+((1-w)*p/w*100)+'%)';}
      t.addEventListener('scroll',u,{passive:true});window.addEventListener('resize',u);u();
    });
    root.querySelectorAll('.mi-res').forEach(function(s){
      if(s.__mi)return;s.__mi=1;
      if(!('IntersectionObserver' in window)){s.classList.add('is-in');return;}
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){s.classList.add('is-in');io.disconnect();}});},{threshold:.2});
      io.observe(s);
    });
    root.querySelectorAll('[data-mi-chr]').forEach(function(c){
      if(c.__mi)return;c.__mi=1;
      var tabs=c.querySelectorAll('[role="tab"]'),panes=c.querySelectorAll('.mi-chr__pane');
      tabs.forEach(function(b,i){b.addEventListener('click',function(){
        tabs.forEach(function(x,j){x.setAttribute('aria-selected',j===i?'true':'false');});
        panes.forEach(function(p,j){p.hidden=j!==i;});
      });});
    });
  }
  function go(){init(document);}
  if(document.readyState!=='loading')go();else document.addEventListener('DOMContentLoaded',go);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
